import { useState, useMemo } from "react";
import { useAPI } from "@/components/lib";

export const usePlayers = () => {
  const [search, setSearch] = useState("");
  const [position, setPosition] = useState("");
  const [playerClass, setPlayerClass] = useState("");
  const [limit, setLimit ] = useState(100);
  const query = useMemo(() => {
    let queryParams = `/api/player/search?limit=${limit}`;
    if (search) {
      const searchNumber = Number(search);
      if (Number.isInteger(searchNumber)) {
        queryParams += `&shirt=${encodeURIComponent(search)}`;
      } else {
        queryParams += `&firstName=${encodeURIComponent(
          search
        )}&lastName=${encodeURIComponent(search)}`;
      }
    }
    if (position) queryParams += `&position=${position}`;
    if (playerClass) queryParams += `&playerClass=${playerClass}`;
    return queryParams;
  }, [search, position, playerClass, limit]);

  const { data: playersList, loading: loadingPlayers } = useAPI(query);
  const { data: settingsData, loading: loadingSettings } =
    useAPI(`/api/settings`);

  const sortedPlayersByOffers =
    playersList?.data?.length > 0
      ? playersList.data.sort((a, b) => {
          const countOffers = (offers) =>
            offers
              ? offers.split(/[,;]/).filter((offer) => offer.trim()).length
              : 0;

          const offersA = countOffers(a.info?.offers);
          const offersB = countOffers(b.info?.offers);

          return offersB - offersA || a.shirt - b.shirt;
        })
      : [];

  return {
    players: sortedPlayersByOffers,
    loadingPlayers,
    setSearch,
    setPosition,
    setPlayerClass,
    settingsData,
    loadingSettings,
    limit,
    setLimit
  };
};
